export default function toggleLeaderBoard(close) {
    const leaderboard = document.querySelector(".leaderboard-container");        
    const infobox = document.querySelector(".infobox-container");
    // const button = document.querySelector(".leaderboard-button");
    const infoboxButton = document.querySelector(".infobox-button");
    
    if (leaderboard.getAttribute("data-state") == "closed" && !close) {
        leaderboard.classList.add("visible");
        // button.classList.add("open");
        // button.querySelector("span").innerHTML = "Hide";
        leaderboard.setAttribute("data-state", "open")

        if (window.innerWidth < 768) {
            infobox.classList.add("hide");
            infoboxButton.querySelector("span").innerHTML = "Exploring Data";
            infobox.setAttribute("data-state", "closed")

            clearTimeout(infoboxTimeout)

            setTimeout(() => {
                infobox.classList.remove("visible");
                infoboxButton.classList.remove("open");
                infobox.classList.remove("hide");
            }, 300);
        }
    }
    //  else {
    //     leaderboard.classList.remove("visible");
    //     button?.classList?.remove("open");
    //     button.querySelector("span").innerHTML = "Top Dashboards";
    //     leaderboard.setAttribute("data-state", "closed")
    // }
}
